<template>
  <div class="p-grid dashboard">
    <div class="p-col-12">
      <Toast />
      <div class="card">
        <div class="title">Daily Omset</div>
        <DataTable
          :value="dailyOmset"
          :paginator="true"
          class="p-datatable-outlets"
          :rows="20"
          :loading="loading"
          data-key="doc_number"
          :rowHover="true"
          :scrollable="true"
          scrollDirection="horizontal"
        >
          <template #header>
            <div class="p-grid p-fluid p-mb-2">
              <div class="p-col">
                <Calendar
                  v-model="start_date"
                  :showIcon="true"
                  dateFormat="yy-mm-dd"
                  placeholder="Start Date"
                  :selectOtherMonths="true"
                  :showButtonBar="true"
                />
              </div>
              <div class="p-col">
                <Calendar
                  v-model="end_date"
                  :showIcon="true"
                  dateFormat="yy-mm-dd"
                  placeholder="End Date"
                  :selectOtherMonths="true"
                  :showButtonBar="true"
                />
              </div>
              <div class="p-col">
                <Button
                  label="Cari"
                  class="p-button-info"
                  @click="getDailyOmset()"
                  v-shortkey.push="['enter']"
                  @shortkey="getDailyOmset()"
                />
              </div>
              <div class="p-col" v-if="dailyOmset.length > 0">
                <router-link
                  :to="{
                    name: 'print-daily-omset',
                    query: {
                      start_date: moment(start_date).format('YYYY-MM-DD'),
                      end_date: moment(end_date).format('YYYY-MM-DD'),
                      outlet_id: user.outlet_id
                    }
                  }"
                  target="_blank"
                >
                  <Button
                    label="Print"
                    icon="pi pi-print"
                    class="p-button-success"
                  />
                </router-link>
              </div>
            </div>
            <table
              class="table table-responsive"
              style="font-size: 16px"
              v-if="dailyOmset.length > 0"
            >
              <thead class="thead-light">
                <tr>
                  <th>Metode Pembayaran</th>
                  <th>Jumlah</th>
                  <th>Total Omset</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(an_item, k) in payment_method" :key="k">
                  <td v-if="an_item.name_payment != 'DISCOUNT'">
                    <h5>{{ an_item.name_payment }}</h5>
                  </td>
                  <td v-if="an_item.name_payment != 'DISCOUNT'">
                    {{ an_item.total_payment | currency }}
                  </td>
                  <td v-if="k == 0">{{ total_omset | currency }}</td>
                </tr>
                <tr>
                  <td>
                    <h5>DISCOUNT CASHIER</h5>
                  </td>
                  <td>{{ total_discount | currency }}</td>
                </tr>
                <tr>
                  <td>
                    <h5>DISCOUNT ITEM</h5>
                  </td>
                  <td>{{ total_discount_item | currency }}</td>
                </tr>
              </tbody>
            </table>
          </template>
          <template #empty>Data tidak ditemukan.</template>
          <template #loading
            >Mengambil data omset harian. Mohon tunggu</template
          >
          <Column
            header="Push Transaction"
            headerStyle="text-align: center; width: 9rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                <Button
                  label="Push"
                  class="p-button-primary"
                  @click="
                    pushTransactionToCloudDialog(slotProps.data.invoice_number)
                  "
                />
              </div>
            </template>
          </Column>
          <Column
            header="Tanggal"
            headerStyle="text-align: center; width: 15rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.trx_date.substr(0, 10) | formatDate }}
              </div>
            </template>
          </Column>
          <Column header="Jam" headerStyle="text-align: center; width: 15rem">
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.trx_date | timestamp }}
              </div>
            </template>
          </Column>
          <Column
            header="Invoice"
            headerStyle="text-align: center; width: 15rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.invoice_number }}
              </div>
            </template>
          </Column>
          <Column
            header="Nama Kasir"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.cashier }}
              </div>
            </template>
          </Column>
          <Column
            header="Kode Barang"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div
                style="text-align: center"
                v-for="(an_item, k) in slotProps.data.items"
                :key="k"
              >
                {{ an_item.code }}
              </div>
            </template>
          </Column>
          <Column
            header="Nama Barang"
            headerStyle="text-align: center; width: 12rem"
          >
            <template #body="slotProps">
              <div
                style="text-align: center"
                v-for="(an_item, k) in slotProps.data.items"
                :key="k"
              >
                {{ an_item.name }}
              </div>
            </template>
          </Column>
          <Column
            header="Kategori"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div
                style="text-align: center"
                v-for="(an_item, k) in slotProps.data.items"
                :key="k"
              >
                {{ an_item.cat_code }}
              </div>
            </template>
          </Column>
          <Column
            header="Harga Jual (Rp)"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div
                style="text-align: center"
                v-for="(an_item, k) in slotProps.data.items"
                :key="k"
              >
                {{ an_item.price | currency }}
              </div>
            </template>
          </Column>
          <Column header="Qty" headerStyle="text-align: center; width: 10rem">
            <template #body="slotProps">
              <div
                style="text-align: center"
                v-for="(an_item, k) in slotProps.data.items"
                :key="k"
              >
                {{ an_item.qty | number }}
              </div>
            </template>
          </Column>
          <Column
            header="Jumlah (Rp)"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div
                style="text-align: center"
                v-for="(an_item, k) in slotProps.data.items"
                :key="k"
              >
                {{ (an_item.price * an_item.qty) | currency }}
              </div>
            </template>
          </Column>
          <Column
            header="Diskon Item (Rp)"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div
                style="text-align: center"
                v-for="(an_item, k) in slotProps.data.items"
                :key="k"
              >
                {{ an_item.discount_item | currency }}
              </div>
            </template>
          </Column>
          <Column
            header="Diskon (Rp)"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.discount | currency }}
              </div>
            </template>
          </Column>
          <Column
            header="Infaq (Rp)"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.infaq | currency }}
              </div>
            </template>
          </Column>
          <Column
            header="Pembulatan (Rp)"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.round_up | currency }}
              </div>
            </template>
          </Column>
          <Column
            header="Voucher (Rp)"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.voucher | currency }}
              </div>
            </template>
          </Column>
          <Column
            header="Omset (Rp)"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.omset | currency }}
              </div>
            </template>
          </Column>
        </DataTable>
      </div>
      <div>
        <Dialog
          :visible.sync="pushTransactionDialog"
          :style="{ width: '500px' }"
          :modal="true"
          :closable="false"
          header="Konfirmasi"
        >
          <div class="confirmation-content">
            <span>
              Apakah anda yakin ingin push invoice
              <b>{{ invoice_number }}</b> ini ke dashboard mobile?
            </span>
          </div>
          <template #footer>
            <Button
              label="Tidak"
              icon="pi pi-times"
              class="p-button-text"
              @click="pushTransactionDialog = false"
            />
            <Button
              label="Ya"
              icon="pi pi-check"
              class="p-button-text"
              @click="pushTransactionToCloud()"
            />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
var moment = require('moment')
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['user', 'isAuthenticated'])
  },
  data() {
    return {
      moment: moment,
      today: new Date().toISOString().split('T')[0],
      loading: true,
      products: null,
      expandedRows: [],
      dailyOmset: null,
      payment_method: null,
      total_omset: 0,
      total_discount: null,
      total_discount_item: null,
      start_date: null,
      end_date: null,
      pushTransactionDialog: false,
      invoice_number: null
    }
  },
  mounted() {
    this.getDailyOmset()
    this.getAuthUser()
  },
  methods: {
    getAuthUser() {
      console.info(this.user)
      this.start_date = this.today
      this.end_date = this.today
    },

    getDailyOmset() {
      this.loading = true
      let start_date = this.start_date
        ? moment(this.start_date).format('YYYY-MM-DD')
        : this.today
      let end_date = this.end_date
        ? moment(this.end_date).format('YYYY-MM-DD')
        : this.today

      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/pos/dailyomset?start_date=${start_date}&end_date=${end_date}`
        )
        .then(response => {
          if (response.status === 200) {
            this.loading = false
            this.dailyOmset = response.data.data.daily_omset
            this.payment_method = response.data.data.payment
            this.total_omset = response.data.data.total_omset
            this.total_discount_item = response.data.data.total_discount_item
            this.total_discount = response.data.data.total_discount
          }
        })
    },

    pushTransactionToCloudDialog(invoice_number) {
      this.pushTransactionDialog = true
      this.invoice_number = invoice_number
    },

    pushTransactionToCloud() {
      this.$http
        .post(
          `${process.env.VUE_APP_API_URL}/pos/push-transaction?invoice_number=${this.invoice_number}`
        )
        .then(response => {
          if (response.status === 200) {
            this.$toast.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Berhasil push transaksi ke cloud',
              life: 3000
            })
            this.pushTransactionDialog = false
            this.invoice_number = null
          } else {
            this.$toast.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Gagal push transaksi ke cloud',
              life: 3000
            })
            this.pushTransactionDialog = false
            this.invoice_number = null
          }
        })
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .p-progressbar {
  height: 0.5rem;
  background-color: #d8dadc;

  .p-progressbar-value {
    background-color: #607d8b;
  }
}

.qty {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 50px;
}

.p-datatable .p-column-filter {
  display: none;
}

.table-header {
  display: flex;
  justify-content: space-between;
}

/deep/ .p-datatable.p-datatable-outlets {
  .p-datatable-header {
    padding: 1rem;
    text-align: left;
    font-size: 1.5rem;
  }

  .p-paginator {
    padding: 1rem;
  }

  .p-datatable-thead > tr > th {
    text-align: left;
  }

  .p-datatable-tbody > tr > td {
    cursor: auto;
  }

  .p-dropdown-label:not(.p-placeholder) {
    text-transform: uppercase;
  }
}

/* Responsive */
.p-datatable-outlets .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

.customer-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-qualified {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-unqualified {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-negotiation {
    background: #feedaf;
    color: #8a5340;
  }

  &.status-new {
    background: #b3e5fc;
    color: #23547b;
  }

  &.status-renewal {
    background: #eccfff;
    color: #694382;
  }

  &.status-proposal {
    background: #ffd8b2;
    color: #805b36;
  }
}

.p-progressbar-value.ui-widget-header {
  background: #607d8b;
}

@media (max-width: 640px) {
  .p-progressbar {
    margin-top: 0.5rem;
  }
}

.product-image {
  width: 100px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.orders-subtable {
  padding: 1rem;
}

.product-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-instock {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-outofstock {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-lowstock {
    background: #feedaf;
    color: #8a5340;
  }
}

.order-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.order-delivered {
    background: #c8e6c9;
    color: #256029;
  }

  &.order-cancelled {
    background: #ffcdd2;
    color: #c63737;
  }

  &.order-pending {
    background: #feedaf;
    color: #8a5340;
  }

  &.order-returned {
    background: #eccfff;
    color: #694382;
  }
}

@media screen and (max-width: 960px) {
  /deep/ .p-datatable {
    &.p-datatable-outlets {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }

      .p-datatable-tbody > tr {
        > td {
          text-align: left;
          display: block;
          border: 0 none !important;
          width: 100% !important;
          float: left;
          clear: left;
          border: 0 none;

          .p-column-title {
            padding: 0.4rem;
            min-width: 30%;
            display: inline-block;
            margin: -0.4rem 1rem -0.4rem -0.4rem;
            font-weight: bold;
          }

          .p-progressbar {
            margin-top: 0.5rem;
          }
        }
      }
    }
  }
}

::v-deep(.p-datatable table) {
  border-collapse: collapse;
}

::v-deep(.p-datatable th),
::v-deep(.p-datatable td) {
  border: 1px solid #ccc !important;
  padding: 8px;
}
</style>
